var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"danger","size":_vm.size},on:{"click":_vm.onClick}},[_c('feather-icon',{attrs:{"icon":"XIcon"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }